import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["m", "mb", "onChange", "alignItems", "display", "ariaLabel", "className", "small", "readOnly", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Note: Do not use this non-form component in your form. Use the core/form/components/Checkbox instead.
 */
import React from 'react';
import styled, { css } from 'styled-components';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { display, space, width } from 'styled-system';
import { Checkbox as BlueprintCheckbox, Classes } from '@blueprintjs/core';
import { formAriaProps, guessByChildText } from '../util/ariaUtils';
var StyledCheckbox = styled(BlueprintCheckbox).withConfig({
  displayName: "Checkbox__StyledCheckbox",
  componentId: "sc-13movhy-0"
})(["&&{&.", "{", ";", ";", "}&.bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator{background-image:none;filter:grayscale(1);}", "}"], Classes.CONTROL, space, width, display, function (props) {
  return !props.labelElement && !props.label && css(["padding-left:16px;.bp4-control-indicator{margin-left:-16px;margin-right:0;}"]);
});
var Checkbox = observer(function (props) {
  // TODO move this into function declaration, can't do it right now since it messes up rename operation
  var _props$m = props.m,
    m = _props$m === void 0 ? 0 : _props$m,
    _props$mb = props.mb,
    mb = _props$mb === void 0 ? '2px' : _props$mb,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    _props$alignItems = props.alignItems,
    _alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
    _props$display = props.display,
    _display = _props$display === void 0 ? 'flex' : _props$display,
    ariaLabel = props.ariaLabel,
    className = props.className,
    small = props.small,
    readOnly = props.readOnly,
    style = props.style,
    rest = _objectWithoutProperties(props, _excluded);
  var handleChange = function handleChange(e) {
    if (!readOnly) {
      onChange(e.currentTarget.checked);
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    // note space us handled by blueprint
    if (e.key === 'Enter') {
      if (!readOnly) {
        onChange(e.currentTarget.checked);
      }
    }
  };
  var ariaLabelGuess = guessByChildText(rest.labelElement) || (rest === null || rest === void 0 ? void 0 : rest.label);
  var ariaProps = formAriaProps(rest, {
    ariaLabel: ariaLabel || ariaLabelGuess,
    ariaSelected: readOnly
  }, {
    enableTabIndexNotDisabled: true,
    passOnExistingAria: true
  });
  return /*#__PURE__*/React.createElement(StyledCheckbox, _extends({}, ariaProps, rest, {
    m: m,
    mb: mb,
    display: _display,
    onKeyDown: handleKeyDown,
    className: classNames(className, _defineProperty({}, Classes.SMALL, small)),
    onChange: handleChange
    // Can't set alignItems directly on StyledCheckbox as React complains
    ,
    style: _objectSpread({
      alignItems: _alignItems
    }, style)
  }));
});
Checkbox.displayName = 'Checkbox';
export default Checkbox;